package twist.mena.sports.admin.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import twist.mena.sports.admin.theme.*

@Composable
fun Modal(
    title: String,
    isOpen: Boolean,
    onClose: () -> Unit,
    maxWidth: CSSpxValue = 500.px,
    content: @Composable () -> Unit
) {
    if (!isOpen) return

    val colors = AppTheme.colors

    Div({
        onClick { onClose() }
        style {
            position(Position.Fixed)
            top(0.px)
            left(0.px)
            right(0.px)
            bottom(0.px)
            property("z-index", "9999")
            backgroundColor(rgba(0, 0, 0, 0.5))
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center)
            padding(Spacing.xl)
            property("overflow-y", "auto")
        }
    }) {
        Div({
            onClick { event -> event.stopPropagation() }
            style {
                backgroundColor(Color(colors.surface))
                borderRadius(BorderRadius.lg)
                property("box-shadow", "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)")
                maxWidth(maxWidth)
                width(100.percent)
                property("max-height", "90vh")
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                border(1.px, LineStyle.Solid, Color(colors.border))
                themeTransition()
            }
        }) {
            // Header
            Div({
                style {
                    display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.SpaceBetween)
                    alignItems(AlignItems.Center)
                    padding(Spacing.xl, Spacing.xxl)
                    property("border-bottom", "1px solid ${colors.border}")
                }
            }) {
                H2({
                    style {
                        margin(0.px)
                        fontSize(Typography.xl)
                        color(Color(colors.text))
                    }
                }) {
                    Text(title)
                }

                Button({
                    onClick { onClose() }
                    style {
                        backgroundColor(Color.transparent)
                        border(0.px)
                        fontSize(Typography.xxl)
                        cursor("pointer")
                        color(Color(colors.textMuted))
                        padding(0.px)
                        width(32.px)
                        height(32.px)
                        display(DisplayStyle.Flex)
                        alignItems(AlignItems.Center)
                        justifyContent(JustifyContent.Center)
                        borderRadius(BorderRadius.sm)
                        property("transition", "background-color 0.2s")
                    }
                }) {
                    Text("\u00D7")
                }
            }

            // Scrollable body
            Div({
                style {
                    padding(Spacing.xxl)
                    property("overflow-y", "auto")
                    property("flex", "1")
                    color(Color(colors.text))
                }
            }) {
                content()
            }
        }
    }
}
